import { render, staticRenderFns } from "./appManage.vue?vue&type=template&id=2c9ccac7"
import script from "./appManage.vue?vue&type=script&lang=js"
export * from "./appManage.vue?vue&type=script&lang=js"
import style0 from "./appManage.vue?vue&type=style&index=0&id=2c9ccac7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports